// Roles list page wrapper.
//
// CHG-1663 / ITER-3772 (Wave 1 / Tier 1 — Roles port).
//
// Thin wrapper around the generator-emitted roleListConfig from
// specs/tier-05-experience/role.entity-hint.yaml. The generated
// config carries title / subtitle / search / pageSize / columns +
// the column override-blocks; this wrapper layers on stateful
// headerActions + the inline Create-role modal mount (modals
// can't live inside a static config constant).

import { useState } from "react";
import { ListPage, type ListPageConfig } from "../components/composition";
import { roleListConfig } from "../generated/screens/role-list";
import type { Role } from "../api/roles";
import { RoleFormModal } from "../components/role/RoleFormModal";

type ModalState = { kind: "create" } | null;

export function Roles() {
  const [modal, setModal] = useState<ModalState>(null);

  // Compose: generated config + stateful headerActions overlay.
  // The generated config's headerActions array is empty (the entity-hint
  // declares `command: openEditRoleFlow` which the generator emits as a
  // forward-promised no-op); the wrapper substitutes the real onClick.
  const config: ListPageConfig<Role> = {
    ...roleListConfig,
    headerActions: [
      {
        id: "new-role",
        label: "New role",
        variant: "primary",
        onClick: () => setModal({ kind: "create" }),
      },
    ],
  };

  return (
    <>
      <ListPage config={config} />
      {modal?.kind === "create" ? (
        <RoleFormModal mode="create" onClose={() => setModal(null)} />
      ) : null}
    </>
  );
}
